import { tv, type VariantProps } from "tailwind-variants";

export const layoutVariant = tv({
  slots: {
    base: [],
    main: ["w-full"],
  },
  variants: {
    showSidebar: {
      true: {
        base: ["relative", "flex", "container-fluid", "!px-0"],
        main: ["pt-6"],
      },
      false: {
        main: [],
      },
    },
  },
  defaultVariants: { showSidebar: false },
});

export type LayoutVariantProps = VariantProps<typeof layoutVariant>;
export type LayoutReturnVariantProps = ReturnType<typeof layoutVariant>;
